// extracted by mini-css-extract-plugin
module.exports = {"nav":"cross-sell_nav__3WBmf"};